export default class BaseEnumerationMember<Type> {
  description: string;
  value: Type;

  constructor(description: string, value: Type) {
    this.description = description;
    this.value = value;
  }
}
